import { useDeleteUser } from "hooks/users";
import { Button, PopupModal } from "shared";

interface DeleteUserModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: () => void;
}

const DeleteUserModal: React.FC<DeleteUserModalProps> = ({
  isOpen,
  onClose,
  onSuccess,
}) => {
  const { mutate: deleteUser } = useDeleteUser();

  const handleDelete = async () => {
    await deleteUser(void 0, {
      onSuccess: () => {
        onSuccess && onSuccess();
        onClose();
      },
    });
  };
  return (
    <PopupModal isOpen={isOpen} onClose={onClose}>
      <h2 className="popup-modal__header popup-modal__header--mb-20">
        Usuwanie konta
      </h2>
      <p className="popup-modal__subtitle">
        Czy jesteś pewien, że chcesz usunąć konto?
      </p>
      <div className="side-modal__buttons">
        <Button
          label="Anuluj"
          onClick={onClose}
          size="large"
          styleType="strokeBlack"
          className="button--wide"
        />
        <Button
          label="Potwierdź"
          onClick={() => handleDelete()}
          styleType="primary"
          size="large"
          className="button--wide"
        />
      </div>
    </PopupModal>
  );
};

export default DeleteUserModal;
